import React from 'react';

interface AnimatedLogoProps {
  size?: number;
  className?: string;
  animationType?: 'rotate' | 'bounce' | 'pulse' | 'float';
}

export const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ 
  size = 80, 
  className = '',
  animationType = 'float'
}) => {
  const getAnimationClass = () => {
    switch (animationType) {
      case 'rotate':
        return 'animate-spin';
      case 'bounce':
        return 'animate-bounce';
      case 'pulse':
        return 'animate-pulse';
      case 'float':
        return 'animate-pulse';
      default:
        return 'animate-pulse';
    }
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 1080 1080"
        className={getAnimationClass()}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <style>
            {`
              .cls-1 { fill: #c8e600; }
              .cls-2 { fill: #ff4a8f; }
              .cls-3 { fill: #3b65f5; }
              
              .logo-part {
                transition: all 0.3s ease;
              }
              
              .logo-part:hover {
                transform: scale(1.1);
                filter: brightness(1.2);
              }
            `}
          </style>
        </defs>
        
        <g className="logo-part">
          <path 
            className="cls-1" 
            d="M454.11,1004.63c-.1-174.56,139.37-316.05,311.51-316.25,172.8-.2,313.13,141.13,311.87,315.89l-623.38.36Z"
          />
        </g>
        
        <g className="logo-part">
          <path 
            className="cls-3" 
            d="M322.67,424.94c147.88,88.11,196.34,279.42,108.23,427.3-88.11,147.88-280.52,195.75-428.4,107.64L322.67,424.94Z"
          />
        </g>
        
        <g className="logo-part">
          <path 
            className="cls-2" 
            d="M895.26,610.25c-147.65,88.49-339.09,40.53-427.58-107.12-88.49-147.65-40.25-339.27,107.4-427.76l320.18,534.88Z"
          />
        </g>
      </svg>
    </div>
  );
};
